<script lang="ts">
  import type { HTMLInputAttributes } from 'svelte/elements';

  interface Props extends HTMLInputAttributes {
    feedback?: string;
    invalid?: boolean;
  }

  let { value = $bindable(), feedback, invalid = false, ...props }: Props = $props();
</script>

<input
  class="form-control"
  class:is-invalid={invalid}
  bind:value
  {...props}
  aria-invalid={invalid ? 'true' : 'false'}
  aria-errormessage={invalid ? `${props.id}_invalid_feedback` : undefined}
/>
{#if feedback}
  <div class="invalid-feedback" id="{props.id}_invalid_feedback">{feedback}</div>
{/if}
